var _defs, _g, _path, _path2, _g2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{stroke:#d3d3d3}.b,.c,.d{fill:none}.b,.c{stroke:#00857c}.c,.d{stroke-linecap:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#d3d3d3",
    fill: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 19,
    rx: 1.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.5 1v18M29 9H1M18.331 8.536c-.738.534-6.931-2.062-4.939-4.709 2.921-2.178 5.259 4.481 4.939 4.709z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M22.156 12.414s-.766-.889-1.76-1.92-2.206-2.206-2.206-2.206"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.875 8.521c-.534-.738 1.99-6.651 4.709-4.939 2.219 2.841-4.481 5.259-4.709 4.939z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.14 12.612a22.25 22.25 0 011.532-1.781c.996-1.058 2.451-2.451 2.451-2.451"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3.5 13.5h5M3.5 16.5h10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftPayment);
export default __webpack_public_path__ + "static/media/GiftPayment.676e45b3adbcf2e27acdf44e31617328.svg";
export { ForwardRef as ReactComponent };